var $a67524a79ccbe190$exports = {};
$a67524a79ccbe190$exports = {
    "alpha": `Alfa`,
    "blue": `Blu`,
    "brightness": `Luminosit\xe0`,
    "green": `Verde`,
    "hue": `Tonalit\xe0`,
    "lightness": `Luminosit\xe0`,
    "red": `Rosso`,
    "saturation": `Saturazione`
};


export {$a67524a79ccbe190$exports as default};
//# sourceMappingURL=it-IT.module.js.map
